import axios from 'axios';
import React from 'react';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import { RouteGroupEverest } from './RouteGroupEverest';
import { RouteGroupQuizShow } from './RouteGroupQuizShow';
import { RouteGroupRealEstate } from './RouteGroupRealEstate';
import { Toast } from './common';
import { LevelUpHome, LuckyDayHomePage, Map2 } from './component';

const isLocal = (window.location.href.indexOf("localhost") > -1);
axios.defaults.headers = {
  "Content-Type": "application/json"
};
axios.defaults.baseURL = isLocal ? "http://localhost:8080" : undefined;
axios.defaults.withCredentials = false;
axios.interceptors.response.use(
  function (res) {
    return res;
  },
  function (err) {
    const res = err.response;
    if (!res) return null;
    if (res.status === 401) {
    } else if (res.status === 409) {
    } else {
      window.Toast && res.data.error && window.Toast.danger(res.data.error);
    }
    return res;
  }
);

function App() {
  return (
    <div className={"App"}>
      <Router>
        <RouteGroupEverest />
        <RouteGroupQuizShow />
        <RouteGroupRealEstate />
        {/* luckyday */}
        <Route exact path={"/luckyday"} component={LuckyDayHomePage} />
        {/* levelup */}
        <Route exact path={"/levelup"} component={LevelUpHome} />
        {/* map */}
        <Route exact path={"/map"} component={Map2} />
        {/* home */}
        <Route exact path={"/"} component={Home} />
      </Router>
      <Toast />
    </div>
  );
}

const Home = () => {
  return (
    <React.Fragment>
      Welcome Home!
    </React.Fragment>
  );
}

export default App;
